import { FormControl } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";

export const CDatePicker = ({
  name,
  value,
  label,
  changeFunction,
  max,
  min,
  disabled,
}) => (
  <FormControl variant="outlined" fullWidth={true} size="small">
    <KeyboardDatePicker
      className="c-date-picker"
      format="dd/MM/yyyy"
      name={name}
      label={label}
      inputVariant="outlined"
      okLabel="Seleccionar"
      cancelLabel="Cancelar"
      invalidDateMessage="Fecha incorrecta"
      maxDateMessage="Fecha incorrecta"
      minDateMessage="Fecha incorrecta"
      value={value ?? null}
      onChange={changeFunction}
      minDate={min ?? false}
      maxDate={max ?? new Date()}
      disableFuture={true}
      disabled={disabled}
      clearable
      clearLabel="Borrar"
    />
  </FormControl>
);
